import ReconnectingWebSocket from 'reconnecting-websocket';
import { URL_CONSTANTS, WEBSOCKETS_MESSAGE_TYPE, WEBSOCKETS_ERROR_CODE, WEBSOCKETS_CONFIGURATION } from '../_constants';
import { websocketsActions } from '../_actions';

import queryString from 'query-string';
import { StoreManager } from '../StoreManager';

export const websocketService = {
    setUp,
    reconnect,
    handleMessage,
};

function setUp(machineUid, apikey) {
    if (process.env.NODE_ENV === "test")
        return;

    if (window.webSocket !== undefined)
        return;

    if (!machineUid || !apikey)
        return; 

    const webSocket = createWebSocket(machineUid, apikey);
    window.webSocket = webSocket;
    addOnMessageEvents(webSocket);
    addRestOfEvents(webSocket);
}

function reconnect(machineUid, apikey) {
    if (window.webSocket !== undefined) {
        window.webSocket.close();
        window.webSocket = undefined;
    }
    websocketService.setUp(machineUid, apikey);
}

function createWebSocket(machineUid, apikey) {
    var url_params = {
        uid: machineUid,
        api_key: apikey,
        keepalive: WEBSOCKETS_CONFIGURATION.KEEP_ALIVE,
    };

    // reconnectionDelayGrowFactor is left alone: at 1 the delay NEVER grew, so a
    // session that is no longer valid retried every few seconds forever. The
    // library default (1.3, capped by maxReconnectionDelay = 10s) keeps the first
    // retry just as fast -- a network blip recovers like before -- and only slows
    // down the one that keeps failing.
    return new ReconnectingWebSocket(URL_CONSTANTS.URL_WEBSOCKET + queryString.stringify(url_params));
}

function addOnMessageEvents(webSocket) {
    webSocket.onmessage = evt => websocketService.handleMessage(webSocket, JSON.parse(evt.data));
}

// Outside the closure so it can be tested: this is where a credential error is
// decided not to be retried.
function handleMessage(webSocket, data) {
    switch (data.action) {
        case WEBSOCKETS_MESSAGE_TYPE.PONG:
            console.log("pong");
            pingTimeout(webSocket);
            break;

        case WEBSOCKETS_MESSAGE_TYPE.GPIO_ORDER:
            StoreManager.getStore().dispatch(websocketsActions.gpioOrderReceived(data.log_data));
            break;

        case WEBSOCKETS_MESSAGE_TYPE.ERROR:
            // An apikey the server no longer recognises is not fixed by
            // retrying: close, and do not reopen until the page reloads with
            // fresh credentials. ReconnectingWebSocket's close() is final (it
            // does not reconnect), unlike a close coming from the server.
            //
            // The HTTP session is deliberately NOT ended here: if that
            // credential is dead too, the app will find out on its next call,
            // which is where that handling lives. Logging the user out from the
            // socket would kick them out over something that may only affect
            // realtime.
            if (data.code === WEBSOCKETS_ERROR_CODE.APIKEY_INVALID) {
                console.warn("websocket: apikey rejected, closing without retry");
                webSocket.close();
                window.webSocket = undefined;
            }
            StoreManager.getStore().dispatch(websocketsActions.error("Websocket error: " + data.message));
            break;

        default:
            console.warn("websocket message:", data);
            break;
    }
}

function addRestOfEvents(webSocket) {
    webSocket.onopen = () => {
        StoreManager.getStore().dispatch(websocketsActions.connected());
        ping(webSocket);
    };

    webSocket.onclose = () => {
        console.warn("websocket disconnected");
    };

    webSocket.onerror = (event) => {
        console.error("websocket error", event);
    };
}

function ping(webSocket) {
    webSocket.send(JSON.stringify({ 'action': WEBSOCKETS_MESSAGE_TYPE.PING }));
    console.log("ping");
}

function pingTimeout(webSocket) {
    setTimeout(
        () => ping(webSocket),
        WEBSOCKETS_CONFIGURATION.TIMEOUT_PING
    );
}